import { webApi } from 'src/services/api/config'
import Cookies from 'js-cookie'
import { AxiosResponse } from 'axios'
import { ApproversRequest } from './approvers.types'

/**
 * Authenticates the user and returns the session data.
 */
export const getApprovers = async (
  approversRequest: ApproversRequest
): Promise<AxiosResponse> => {
  return await webApi.get('api/users/approved/' + approversRequest.userId, {
    headers: {
      'Content-Type': 'application/json',
      Authorization:
        'bearer ' + (Cookies.get('auth-token') ? Cookies.get('auth-token') : '')
    }
  })
}
